import { AnimatedModal, getMobileWidth, theme } from '@atomica.co/components';
import { Height } from '@atomica.co/utils';
import React from 'react';
import styled from 'styled-components';

interface P {
  isOpen: boolean;
  children: React.ReactNode;
  onClose(): void;
}

const FullModal: React.FC<P> = React.memo(props => {
  const { isOpen, children, onClose } = props;

  return (
    <AnimatedModal isOpen={isOpen} height={window.innerHeight} onClose={onClose}>
      <Container>
        <Frame height={window.innerHeight}>{children}</Frame>
      </Container>
    </AnimatedModal>
  );
});

export default FullModal;

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  ${theme.mixins.userSelectDisabled};
`;

const Frame = styled.div<{ height: Height }>`
  width: ${getMobileWidth()}px;
  height: ${props => props.height}px;
  background: ${theme.mixins.background.white};
`;
